<template>
  <CustomPicker
    :isInDialog="isInDialog"
    :isLoading="isLoading"
    :multiple="multiple"
    :closeOnSelect="closeOnSelect"
    title="fullName"
    :selectable="selectable"
    :inputLabel="inputLabel"
    v-model="selectedUser"
    :items="usersList"
    @search="handleSearch"
  >
    <template #labelOption="data">
      <span dir="rtl" style="text-align: right !important">
        <bdi>
          {{ data.item.fullName }}
          <template v-if="data.item.mobile">
            ({{ data.item.mobile }})
          </template>
        </bdi>
      </span>
    </template>
  </CustomPicker>
</template>
<script>
export default {
  emits: ["getStudentUserId"],
  mounted() {
    this.getAllUsersList();
  },
  props: {
    multiple: {
      type: Boolean,
      default: false,
    },
    isInDialog: {
      type: Boolean,
      default: false,
    },
    closeOnSelect: {
      type: Boolean,
      default: true,
    },
    selectable: {
      type: Function,
      default: () => true,
    },
    inputLabel: {
      type: String,
      default: "زبان آموز را انتخاب کنید",
    },
  },
  watch: {
    selectedUser: {
      handler(val) {
        this.$emit("getStudentUserId", val?.userId || null);
      },
    },
  },
  data() {
    return {
      isLoading: false,
      usersList: null,
      selectedUser: null,
      searchVal: null,
      timeout: null,
    };
  },
  methods: {
    handleSearch(searchValue, loadingFn) {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(async () => {
        this.searchVal = searchValue;
        loadingFn(true);
        await this.getAllUsersList();
        loadingFn(false);
      }, 300);
    },
    async getAllUsersList() {
      try {
        this.isLoading = true;
        let reqParams = {
          count: 10,
          pageNumber: 1,
          type: 4,
        };
        if (this.searchVal && this.searchVal != "") {
          reqParams["fullname"] = this.searchVal;
        }
        let _this = this;
        let getAllUsersList = new GetAllUsersList(_this);
        getAllUsersList.setRequestParamDataObj(reqParams);
        await getAllUsersList.fetch((response) => {
          if (response.isSuccess) {
            _this.usersList = response.data.users;
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  components: {
    CustomPicker,
  },
};
import CustomPicker from "@/views/components/Utils/CustomPicker.vue";
import { GetAllUsersList } from "@/libs/Api/Users";
</script>
